export const DataManagerReducer = (state, action) => {
    switch (action.type) {
      case "DATA_MANAGE":
        return action.payload;
  
      default:
        return state;
    }
  };